import React from 'react';
import { Badge, Box, Image } from 'pcln-design-system';
import styled from 'styled-components';
const BadgeWrapper = /*#__PURE__*/styled(Badge).withConfig({
  displayName: "ExpressDealBadge__BadgeWrapper",
  componentId: "sc-hm59r5-0"
})(["position:absolute;top:12px;left:12px;"]);
const RelativeBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "ExpressDealBadge__RelativeBox",
  componentId: "sc-hm59r5-1"
})(["position:relative;"]);
export const ExpressDealBadge = () => {
  return React.createElement(RelativeBox, null, React.createElement(BadgeWrapper, {
    bg: 'background.lightest'
  }, React.createElement(Image, {
    height: 12,
    src: 'https://s1.pclncdn.com/design-assets/brand-assets/express-deal-logo-tm.svg'
  })));
};
export default ExpressDealBadge;